/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['[_nghost-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%}.calendar[_ngcontent-%COMP%]{-webkit-box-flex:1;-ms-flex:1;flex:1}.external-events[_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 1 150px;flex:0 1 150px;padding:0 10px;border:1px solid #ccc;background:#eee;margin-right:20px}.external-events__title[_ngcontent-%COMP%]{padding-top:1em}.external-event[_ngcontent-%COMP%]{margin:10px 0;cursor:pointer;background-color:#e76049;color:#fff;padding:2px 10px}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2NhbGVuZGFyL2NhbGVuZGFyLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2NhbGVuZGFyL2NhbGVuZGFyLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./$$_gendir/src/app/shared/calendar/calendar.component.scss.shim.ngstyle.ts